import { useEffect, useMemo, useState } from 'react';
import { managerApi } from '../../lib/api';
import { waLink } from '../../lib/whatsapp';
import { errorMessage } from '../../components/ErrorModalBody';

type Canal = 'push' | 'whatsapp' | 'ambos';

export function ComunicadorTab() {
  const [employees, setEmployees] = useState<any[]>([]);
  const [camarotes, setCamarotes] = useState<string[]>([]);
  const [camarote, setCamarote] = useState('todos');
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const [mensagem, setMensagem] = useState('');
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);
  const [results, setResults] = useState<any[]>([]);
  const [waList, setWaList] = useState<{ nome: string; link: string }[]>([]);

  useEffect(() => {
    setLoading(true);
    Promise.all([managerApi.listEmployees(), managerApi.getConfig()]).then(([emp, cfg]) => {
      const ativos = emp.employees.filter((e: any) => e.ativo);
      setEmployees(ativos);
      setCamarotes(cfg.config.camarotes);
      setSelected(new Set(ativos.map((e: any) => e.id)));
    }).finally(() => setLoading(false));
  }, []);

  const visiveis = useMemo(() => camarote === 'todos' ? employees : employees.filter((e) => e.camarote === camarote), [employees, camarote]);
  const selecionados = useMemo(() => visiveis.filter((e) => selected.has(e.id)), [visiveis, selected]);

  function toggle(id: string) {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  }
  function toggleAll() {
    setSelected((prev) => {
      const allSelected = visiveis.every((e) => prev.has(e.id));
      const next = new Set(prev);
      visiveis.forEach((e) => allSelected ? next.delete(e.id) : next.add(e.id));
      return next;
    });
  }

  async function enviar(canal: Canal) {
    if (!mensagem.trim()) { alert('Escreva a mensagem antes de enviar.'); return; }
    if (selecionados.length === 0) { alert('Selecione ao menos um funcionário.'); return; }
    setSending(true);
    setResults([]);
    setWaList([]);
    try {
      if (canal === 'push' || canal === 'ambos') {
        const res = await managerApi.sendPushBroadcast(selecionados.map((e) => e.id), mensagem.trim());
        setResults(res.results);
      }
      if (canal === 'whatsapp' || canal === 'ambos') {
        const list = selecionados.filter((e) => e.telefone).map((e) => ({ nome: e.nome, link: waLink(e.telefone, `Coala: ${mensagem.trim()}`) }));
        setWaList(list);
      }
    } catch (err) {
      alert(errorMessage(err));
    } finally {
      setSending(false);
    }
  }

  if (loading) return <div className="card"><p className="muted">Carregando…</p></div>;

  return (
    <>
      <div className="card">
        <h2>Comunicador</h2>
        <p className="hint">Mande um aviso livre para a equipe — ex.: "portas abrindo em breve" ou "almoço liberado". Mesmos canais dos lembretes.</p>
        <label>Mensagem</label>
        <textarea placeholder="Escreva o aviso..." value={mensagem} onChange={(e) => setMensagem(e.target.value)} />
        <label>Camarote</label>
        <select value={camarote} onChange={(e) => setCamarote(e.target.value)}>
          <option value="todos">Todos os camarotes</option>
          {camarotes.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <div className="toolbar" style={{ marginTop: 10 }}>
          <button className="btn btn-ghost btn-sm" onClick={toggleAll}>{visiveis.every((e) => selected.has(e.id)) ? 'Desmarcar todos' : 'Selecionar todos'}</button>
          <span className="muted">{selecionados.length} selecionado(s)</span>
        </div>
        <div className="row" style={{ marginTop: 10 }}>
          <button className="btn btn-primary btn-sm" style={{ flex: 1 }} disabled={sending} onClick={() => enviar('push')}>Enviar por Notificação</button>
          <button className="btn btn-teal btn-sm" style={{ flex: 1 }} disabled={sending} onClick={() => enviar('whatsapp')}>Enviar por WhatsApp</button>
          <button className="btn btn-gold btn-sm" style={{ flex: 1 }} disabled={sending} onClick={() => enviar('ambos')}>Notificação + WhatsApp</button>
        </div>
      </div>

      {waList.length > 0 && (
        <div className="card">
          <h2>Links do WhatsApp</h2>
          <p className="hint">Clique em cada botão — abre o WhatsApp Web/app com a mensagem já escrita, só confirmar o envio.</p>
          {waList.map((w) => (
            <a key={w.nome} className="btn btn-teal btn-block" style={{ marginBottom: 8, textDecoration: 'none' }} href={w.link} target="_blank" rel="noreferrer">Enviar para {w.nome}</a>
          ))}
        </div>
      )}

      <div className="card">
        <h2>Destinatários ({visiveis.length})</h2>
        {visiveis.map((e) => {
          const resultado = results.find((r) => r.id === e.id);
          return (
            <label className="checkrow" style={{ marginTop: 8, alignItems: 'center', display: 'flex', gap: 8 }} key={e.id}>
              <input type="checkbox" checked={selected.has(e.id)} onChange={() => toggle(e.id)} />
              <span>{e.nome}</span>
              <span className="muted" style={{ marginLeft: 'auto' }}>{e.camarote}</span>
              {resultado && <span className={`pill ${resultado.sucesso ? 'pill-ok' : 'pill-pending'}`}>{resultado.sucesso ? '✓' : resultado.detalhe}</span>}
            </label>
          );
        })}
      </div>
    </>
  );
}
